export default __webpack_public_path__ + "static/media/order.9cabaa32.svg";